import { Component, OnInit, PLATFORM_ID, Inject, AfterViewInit, ChangeDetectorRef, HostListener } from '@angular/core';
import { Router, NavigationEnd, NavigationStart, NavigationCancel, NavigationError, Event } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import { SharedService } from 'src/app/services/shared.service';
//services
import {HttpService} from 'src/app/services/http.service';
import {StoreService} from 'src/app/services/store.service';
import {LoadingService} from 'src/app/services/loading.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterViewInit {
  title: string;
  isloading: boolean = false;
  route_path: string;

  isShow: boolean;
  topPosToStartShowing = 430;

  resFavicon : any;
  data: any;

  restaurant_address: string;
  isOpenChatBox : boolean = false;
  isActiveWaFeature = false;
  waNumbuer: any;
  

  constructor(
    @Inject(PLATFORM_ID) private readonly platformId: any,
    private router: Router,
    public cdr: ChangeDetectorRef,
    private httpService: HttpService,
    private storeService: StoreService,
    private sharedService: SharedService,
    private loadingService: LoadingService
  ) {

    if (this.platformId === 'browser') {
      this.router.events.subscribe((event: Event) => {
        if (event instanceof NavigationStart) {
          this.loadingService.loadingStart();
        }
        if (event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError) {
          this.route_path = event.url.replace('/', '');
          setTimeout(() => {
            this.loadingService.loadingClose();
          }, 2000);
        }
      });
    }
  }

  ngOnInit() {
    this.getRestaurantData();

    const templateName = "Thai Template Black";
    const version = "1.00";
    console.log(`Template name: ${templateName}`);
    console.log(`Version: ${version}`);
  }
  ngAfterViewInit() {
    this.loadingService.loading$.subscribe((val) => {
      this.isloading = val;
      this.cdr.detectChanges();
    })
  }

  getRestaurantData() {
    if (this.platformId === 'browser') {
      this.loadingService.loadingStart();
      this.httpService.findRestaurantData().subscribe(result => {
        if (result['status']) {
          this.data = result['data'];
          this.saveSelectedRestaurantFullWeekSchedule(result['data'].restaurant_data.restaurant_id);
          this.storeService.saveRestaurantData(result['data']);
          localStorage.setItem('restaurant_id', result['data'].restaurant_data.restaurant_id);
          this.resFavicon = result['data']?.restaurant_data?.favicon;
          this.setDynamicFavicon();

          this.isActiveWaFeature = this.data?.restaurant_data?.social_login?.whatsapp?.is_active;
          if(this.isActiveWaFeature){
            this.waNumbuer = this.data?.restaurant_data?.social_login?.whatsapp?.target_mobile;
          }

          let res_postcode = '';
          if (this.data.restaurant_data.street_address) {
            res_postcode = res_postcode.concat(', ' + this.data.restaurant_data.street_address.replace(/,\s*$/, '').trim());
          }
          if (this.data.restaurant_data.local_area) {
            res_postcode = res_postcode.concat(', ' + this.data.restaurant_data.local_area.replace(/,\s*$/, '').trim());
          }
          if (this.data.restaurant_data.city_or_town) {
            res_postcode = res_postcode.concat(', ' + this.data.restaurant_data.city_or_town.replace(/,\s*$/, '').trim());
          }
          if (this.data.restaurant_data.postcode) {
            res_postcode = res_postcode.concat(', ' + this.data.restaurant_data.postcode.trim());
          }
          this.restaurant_address = res_postcode.replace(/^,/, '').trim();

        }
        setTimeout(() => {
          this.loadingService.loadingClose();
        }, 2000);
      }, err => {
        this.loadingService.loadingClose();
        this.router.navigate(['/network-error']);
      });
    }
  }

  setDynamicFavicon() {
    const faviconLink = document.getElementById('dynamicFavicon') as HTMLLinkElement;
    
    const dynamicFaviconPath = this.resFavicon ? this.resFavicon : '../assets/images/favicon-icon.png';


    if (faviconLink) {
      faviconLink.href = dynamicFaviconPath;
    } else {
      // If the link element doesn't exist, create and append it to the document head
      const newFaviconLink = document.createElement('link');
      newFaviconLink.id = 'dynamicFavicon';
      newFaviconLink.rel = 'icon';
      newFaviconLink.type = 'image/x-icon';
      newFaviconLink.href = dynamicFaviconPath;

      document.head.appendChild(newFaviconLink);
    }
  }

  onActivate() {
    if (this.platformId === 'browser') {
      window.scroll(0, 0);
      document.querySelector('body').style.removeProperty('overflow');
    }
  }


  @HostListener('window:scroll')

  checkScroll() {
    const scrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    
    if (scrollPosition >= this.topPosToStartShowing) {
      this.isShow = true;
    } else {
      this.isShow = false;
    }
  }

  gotoTop() {
    window.scroll({ 
      top: 0, 
      left: 0, 
      behavior: 'smooth' 
    });
  }

  chatBoxClicked(e: any){
    e.stopPropagation();
    this.isOpenChatBox = !this.isOpenChatBox;
  }

  chatBoxBodyClicked(e: any){
    e.stopPropagation();
  }
  bodyClicked(){
    this.isOpenChatBox = false;
  }

  saveSelectedRestaurantFullWeekSchedule(resId: any) {
    if (!isPlatformBrowser(this.platformId)) return;
    if (!resId) return;

    sessionStorage.removeItem('fullweekschedule');
    this.sharedService.weeklyScheduleReady = new Promise<void>(resolve => {
      this.httpService.fetchRestaurantSchedule(resId).subscribe((res: any) => {
        if (res && res.status) {
          sessionStorage.setItem('fullweekschedule', JSON.stringify(res.data));
        }
        resolve();
      }, () => resolve());
    });
  }

}
